import { useSelector } from "react-redux";
import TreeViewNavbar from "../../components/Tree/TreeViewNavbar";
import SponserTreeContent from "../../components/Tree/sponser-tree/SponserTreeContent";
import { useEffect, useState } from "react";
import { getUserDefaultPlan } from "../../utils/defaultPlan";

const SponserTree = () => {
  const [selectedUserId, setSelectedUserId] = useState("");
  const [searchUsername, setSearchUsername] = useState("");
  const [doubleClickedUser, setDoubleClickedUser] = useState("");
  const [treePlan, setTreePlan] = useState(null);
  const userPlans = useSelector((state) => {
    return state.dashboard?.appLayout?.userplans;
  });
  const userDefaultPlan = getUserDefaultPlan();

  useEffect(() => {
    if (userDefaultPlan) {
      setTreePlan(userDefaultPlan);
    } else if (userPlans?.defaultPlan) {
      setTreePlan(userPlans.defaultPlan);
    }
  }, [userPlans, userDefaultPlan]);
  useEffect(() => {
    setSelectedUserId("");
  }, [treePlan]);
  return (
    <>
      {treePlan && <> <TreeViewNavbar
        menu={"sponsorTree"}
        searchUsername={searchUsername}
        setSearchUsername={setSearchUsername}
        setSelectedUserId={setSelectedUserId}
        treePlan={treePlan}
        setTreePlan={setTreePlan}
      />
        <SponserTreeContent
          selectedUserId={selectedUserId}
          setSelectedUserId={setSelectedUserId}
          doubleClickedUser={doubleClickedUser}
          setDoubleClickedUser={setDoubleClickedUser}
          searchUsername={searchUsername}
          setSearchUsername={setSearchUsername}
          treePlan={treePlan}
        />
      </>

      }
    </>
  );
};

export default SponserTree;
